import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AnagClienti } from '../models/models/pages/anagclienti';

@Injectable({ providedIn: 'root' })
export class AnagClientiService {
    private baseUrl = `${environment.baseApiUrl}/anag-clienti`;

    constructor(private http: HttpClient) {}

    /** Lista semplice (array) */
    list(params?: { page?: number; size?: number; sort?: string }): Observable<AnagClienti[]> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http.get<AnagClienti[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true
        });
    }

    listPage(params?: { page?: number; size?: number; sort?: string }): Observable<{ content: AnagClienti[]; total: number }> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http
            .get<AnagClienti[]>(this.baseUrl, {
                params: httpParams,
                withCredentials: true,
                observe: 'response'
            })
            .pipe(
                map((res) => ({
                    content: res.body ?? [],
                    total: Number(res.headers.get('X-Total-Count') ?? res.body?.length ?? 0)
                }))
            );
    }

    get(id: number): Observable<AnagClienti> {
        return this.http.get<AnagClienti>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    create(payload: Omit<AnagClienti, 'id'>): Observable<AnagClienti> {
        // return this.http.post<AnagClienti>(this.baseUrl, payload, { withCredentials: true });
        return this.http.post<AnagClienti>(this.baseUrl, payload, { withCredentials: true });
    }

    update(entity: AnagClienti): Observable<AnagClienti> {
        //const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json', 'x-xsrf-token': 'e3485aaf-e75a-4326-97b8-54bef539aa4c' });
        return this.http.put<AnagClienti>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    partialUpdate(id: number, patch: Partial<AnagClienti>): Observable<AnagClienti> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<AnagClienti>(`${this.baseUrl}/${id}`, patch, { headers, withCredentials: true });
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }
}
